/** Published combinations only. This metadata ships in the shell; page copy does not. */
export const SUBJECT_PAGES = [
  {
    path: '/english',
    subject: 'english',
    id: 'english',
    label: 'English overview',
    kind: 'subject',
    hub: true,
    parent: null,
    year: null,
    course: null,
  },
  {
    path: '/english/g1',
    subject: 'english',
    id: 'english-g1',
    label: 'G1 English',
    kind: 'course',
    hub: false,
    parent: '/english',
    year: null,
    course: 'g1',
  },
  {
    path: '/english/g2',
    subject: 'english',
    id: 'english-g2',
    label: 'G2 English',
    kind: 'course',
    hub: false,
    parent: '/english',
    year: null,
    course: 'g2',
  },
  {
    path: '/english/g3',
    subject: 'english',
    id: 'english-g3',
    label: 'O-Level / SEC English (G3)',
    kind: 'course',
    hub: false,
    parent: '/english',
    year: null,
    course: 'g3',
  },
  {
    path: '/english/ip',
    subject: 'english',
    id: 'english-ip',
    label: 'IP English & Language Arts',
    kind: 'course',
    hub: false,
    parent: '/english',
    year: null,
    course: 'ip',
  },
  {
    path: '/english/ib',
    subject: 'english',
    id: 'english-ib',
    label: 'IB pathway English (Sec 1–4)',
    kind: 'course',
    hub: false,
    parent: '/english',
    year: null,
    course: 'ib',
  },
  {
    path: '/english/exam-format',
    subject: 'english',
    id: 'english-exam-format',
    label: 'English exam format',
    kind: 'guide',
    hub: false,
    parent: '/english',
    year: null,
    course: null,
  },
  {
    path: '/english/sec-1',
    subject: 'english',
    id: 'english-sec-1',
    label: 'Secondary 1 English',
    kind: 'year',
    hub: false,
    parent: '/english',
    year: 1,
    course: null,
  },
  {
    path: '/english/sec-1/g1',
    subject: 'english',
    id: 'english-sec-1-g1',
    label: 'Sec 1 G1 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-1',
    year: 1,
    course: 'g1',
  },
  {
    path: '/english/sec-1/g2',
    subject: 'english',
    id: 'english-sec-1-g2',
    label: 'Sec 1 G2 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-1',
    year: 1,
    course: 'g2',
  },
  {
    path: '/english/sec-1/g3',
    subject: 'english',
    id: 'english-sec-1-g3',
    label: 'Sec 1 G3 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-1',
    year: 1,
    course: 'g3',
  },
  {
    path: '/english/sec-1/ip',
    subject: 'english',
    id: 'english-sec-1-ip',
    label: 'Sec 1 IP English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-1',
    year: 1,
    course: 'ip',
  },
  {
    path: '/english/sec-1/ib',
    subject: 'english',
    id: 'english-sec-1-ib',
    label: 'Sec 1 IB pathway English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-1',
    year: 1,
    course: 'ib',
  },
  {
    path: '/english/sec-2',
    subject: 'english',
    id: 'english-sec-2',
    label: 'Secondary 2 English',
    kind: 'year',
    hub: false,
    parent: '/english',
    year: 2,
    course: null,
  },
  {
    path: '/english/sec-2/g1',
    subject: 'english',
    id: 'english-sec-2-g1',
    label: 'Sec 2 G1 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-2',
    year: 2,
    course: 'g1',
  },
  {
    path: '/english/sec-2/g2',
    subject: 'english',
    id: 'english-sec-2-g2',
    label: 'Sec 2 G2 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-2',
    year: 2,
    course: 'g2',
  },
  {
    path: '/english/sec-2/g3',
    subject: 'english',
    id: 'english-sec-2-g3',
    label: 'Sec 2 G3 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-2',
    year: 2,
    course: 'g3',
  },
  {
    path: '/english/sec-2/ip',
    subject: 'english',
    id: 'english-sec-2-ip',
    label: 'Sec 2 IP English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-2',
    year: 2,
    course: 'ip',
  },
  {
    path: '/english/sec-2/ib',
    subject: 'english',
    id: 'english-sec-2-ib',
    label: 'Sec 2 IB pathway English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-2',
    year: 2,
    course: 'ib',
  },
  {
    path: '/english/sec-3',
    subject: 'english',
    id: 'english-sec-3',
    label: 'Secondary 3 English',
    kind: 'year',
    hub: false,
    parent: '/english',
    year: 3,
    course: null,
  },
  {
    path: '/english/sec-3/g1',
    subject: 'english',
    id: 'english-sec-3-g1',
    label: 'Sec 3 G1 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-3',
    year: 3,
    course: 'g1',
  },
  {
    path: '/english/sec-3/g2',
    subject: 'english',
    id: 'english-sec-3-g2',
    label: 'Sec 3 G2 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-3',
    year: 3,
    course: 'g2',
  },
  {
    path: '/english/sec-3/g3',
    subject: 'english',
    id: 'english-sec-3-g3',
    label: 'Sec 3 G3 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-3',
    year: 3,
    course: 'g3',
  },
  {
    path: '/english/sec-3/ip',
    subject: 'english',
    id: 'english-sec-3-ip',
    label: 'Sec 3 IP English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-3',
    year: 3,
    course: 'ip',
  },
  {
    path: '/english/sec-3/ib',
    subject: 'english',
    id: 'english-sec-3-ib',
    label: 'Sec 3 IB pathway English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-3',
    year: 3,
    course: 'ib',
  },
  {
    path: '/english/sec-4',
    subject: 'english',
    id: 'english-sec-4',
    label: 'Secondary 4 English',
    kind: 'year',
    hub: false,
    parent: '/english',
    year: 4,
    course: null,
  },
  {
    path: '/english/sec-4/g1',
    subject: 'english',
    id: 'english-sec-4-g1',
    label: 'Sec 4 G1 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-4',
    year: 4,
    course: 'g1',
  },
  {
    path: '/english/sec-4/g2',
    subject: 'english',
    id: 'english-sec-4-g2',
    label: 'Sec 4 G2 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-4',
    year: 4,
    course: 'g2',
  },
  {
    path: '/english/sec-4/g3',
    subject: 'english',
    id: 'english-sec-4-g3',
    label: 'Sec 4 G3 English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-4',
    year: 4,
    course: 'g3',
  },
  {
    path: '/english/sec-4/ip',
    subject: 'english',
    id: 'english-sec-4-ip',
    label: 'Sec 4 IP English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-4',
    year: 4,
    course: 'ip',
  },
  {
    path: '/english/sec-4/ib',
    subject: 'english',
    id: 'english-sec-4-ib',
    label: 'Sec 4 IB pathway English',
    kind: 'year-course',
    hub: false,
    parent: '/english/sec-4',
    year: 4,
    course: 'ib',
  },
  {
    path: '/chemistry',
    subject: 'chemistry',
    id: 'chemistry',
    label: 'Secondary Chemistry',
    kind: 'subject',
    hub: true,
    parent: null,
    year: null,
    course: null,
  },
  {
    path: '/chemistry/pure-chemistry',
    subject: 'chemistry',
    id: 'pure-chemistry',
    label: 'Pure Chemistry',
    kind: 'course',
    hub: false,
    parent: '/chemistry',
    year: null,
    course: 'pure-chemistry',
  },
  {
    path: '/chemistry/combined-science',
    subject: 'chemistry',
    id: 'combined-science',
    label: 'Combined Science (Chemistry)',
    kind: 'course',
    hub: false,
    parent: '/chemistry',
    year: null,
    course: 'combined-science',
  },
  {
    path: '/chemistry/syllabus',
    subject: 'chemistry',
    id: 'chemistry-syllabus',
    label: 'Chemistry syllabus',
    kind: 'guide',
    hub: false,
    parent: '/chemistry',
    year: null,
    course: null,
  },
  {
    path: '/chemistry/sec-3',
    subject: 'chemistry',
    id: 'chemistry-sec-3',
    label: 'Secondary 3 Chemistry',
    kind: 'year',
    hub: false,
    parent: '/chemistry',
    year: 3,
    course: null,
  },
  {
    path: '/chemistry/sec-3/pure-chemistry',
    subject: 'chemistry',
    id: 'chemistry-sec-3-pure-chemistry',
    label: 'Sec 3 Pure Chemistry',
    kind: 'year-course',
    hub: false,
    parent: '/chemistry/sec-3',
    year: 3,
    course: 'pure-chemistry',
  },
  {
    path: '/chemistry/sec-3/combined-science-g3',
    subject: 'chemistry',
    id: 'chemistry-sec-3-combined-science-g3',
    label: 'Sec 3 Combined Science (Chemistry) G3',
    kind: 'year-course',
    hub: false,
    parent: '/chemistry/sec-3',
    year: 3,
    course: 'combined-science-g3',
  },
  {
    path: '/chemistry/sec-3/combined-science-g2',
    subject: 'chemistry',
    id: 'chemistry-sec-3-combined-science-g2',
    label: 'Sec 3 Combined Science (Chemistry) G2',
    kind: 'year-course',
    hub: false,
    parent: '/chemistry/sec-3',
    year: 3,
    course: 'combined-science-g2',
  },
  {
    path: '/chemistry/sec-4',
    subject: 'chemistry',
    id: 'chemistry-sec-4',
    label: 'Secondary 4 Chemistry',
    kind: 'year',
    hub: false,
    parent: '/chemistry',
    year: 4,
    course: null,
  },
  {
    path: '/chemistry/sec-4/pure-chemistry',
    subject: 'chemistry',
    id: 'chemistry-sec-4-pure-chemistry',
    label: 'Sec 4 Pure Chemistry',
    kind: 'year-course',
    hub: false,
    parent: '/chemistry/sec-4',
    year: 4,
    course: 'pure-chemistry',
  },
  {
    path: '/chemistry/sec-4/combined-science-g3',
    subject: 'chemistry',
    id: 'chemistry-sec-4-combined-science-g3',
    label: 'Sec 4 Combined Science (Chemistry) G3',
    kind: 'year-course',
    hub: false,
    parent: '/chemistry/sec-4',
    year: 4,
    course: 'combined-science-g3',
  },
  {
    path: '/chemistry/sec-4/combined-science-g2',
    subject: 'chemistry',
    id: 'chemistry-sec-4-combined-science-g2',
    label: 'Sec 4 Combined Science (Chemistry) G2',
    kind: 'year-course',
    hub: false,
    parent: '/chemistry/sec-4',
    year: 4,
    course: 'combined-science-g2',
  },
  {
    path: '/chemistry/ip',
    subject: 'chemistry',
    id: 'chemistry-ip',
    label: 'IP Chemistry',
    kind: 'course',
    hub: false,
    parent: '/chemistry',
    year: null,
    course: 'ip',
  },
  {
    path: '/chemistry/sec-3/ip',
    subject: 'chemistry',
    id: 'chemistry-sec-3-ip',
    label: 'Sec 3 IP Chemistry',
    kind: 'year-course',
    hub: false,
    parent: '/chemistry/sec-3',
    year: 3,
    course: 'ip',
  },
  {
    path: '/chemistry/sec-4/ip',
    subject: 'chemistry',
    id: 'chemistry-sec-4-ip',
    label: 'Sec 4 IP Chemistry',
    kind: 'year-course',
    hub: false,
    parent: '/chemistry/sec-4',
    year: 4,
    course: 'ip',
  },
] as const;

export type SubjectPageRoute = (typeof SUBJECT_PAGES)[number];
export type SubjectPagePath = SubjectPageRoute['path'];
export type SubjectPageId = SubjectPageRoute['id'];
export const SUBJECT_PAGE_PATHS = SUBJECT_PAGES.map(page => page.path);
export function isSubjectPagePath(value: unknown): value is SubjectPagePath {
  return (
    typeof value === 'string' && SUBJECT_PAGE_PATHS.some(path => path === value)
  );
}

export function getSubjectPage(path: SubjectPagePath): SubjectPageRoute {
  return SUBJECT_PAGES.find(page => page.path === path)!;
}

export function subjectBreadcrumbs(page: SubjectPageRoute) {
  const parents: { name: string; path: SubjectPagePath }[] = [];
  let parent: SubjectPagePath | null = page.parent;
  while (parent) {
    const ancestor = getSubjectPage(parent);
    parents.unshift({ name: ancestor.label, path: ancestor.path });
    parent = ancestor.parent;
  }
  return parents;
}

/** Navigation follows the same published hierarchy as routing and breadcrumbs. */
export function subjectRelatedPages(page: SubjectPageRoute) {
  return SUBJECT_PAGES.filter(candidate => {
    if (candidate.parent === page.path) return true;
    if (
      page.kind !== 'course' ||
      candidate.subject !== page.subject ||
      candidate.kind !== 'year-course'
    )
      return false;
    return (
      candidate.course === page.course ||
      (page.course === 'combined-science' &&
        candidate.course.startsWith('combined-science-'))
    );
  });
}
